export default __webpack_public_path__ + "static/media/playbackPlay.639fe5d9.svg";